import { FluentProvider } from '@fluentui/react-components';
import { parseUtcDate } from '@moko/utils';
import { useActiveTheme } from '../../theme/ThemeContext';
import { DateTimeSelect } from '../../DateTimeSelect';
import { useOtherInfoContext } from '../OtherInfoContext';
import { FieldWrapper } from './FieldWrapper';
import type { FieldComponentProps } from './types';

export const DateTimeField = ({
  field,
  fieldValue,
  isFieldDisabled,
  validationMessage,
}: FieldComponentProps) => {
  const { handleOtherInfoChange, validateField } = useOtherInfoContext();
  const theme = useActiveTheme();
  const parsed = fieldValue ? parseUtcDate(fieldValue as string | Date) : null;
  const value = parsed && !Number.isNaN(parsed.getTime()) ? parsed : null;

  return (
    <FieldWrapper field={field} validationMessage={validationMessage}>
      <FluentProvider theme={theme} style={{ width: '100%' }}>
        <DateTimeSelect
          value={value}
          disabled={isFieldDisabled}
          onChange={(next) => {
            const iso = next ? next.toISOString() : undefined;
            handleOtherInfoChange(field.name, iso);
            validateField(field.name, iso);
          }}
        />
      </FluentProvider>
    </FieldWrapper>
  );
};
